import { motion } from 'framer-motion';

export default function FloatingButtons() {
  const whatsappNumber = '919281410305';
  const whatsappMessage = encodeURIComponent('Hello, I want information about travel packages.');
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;

  return (
    <>
      {/* WhatsApp Button - Bottom Left */}
      <motion.a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-24 left-6 z-50"
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 1, type: 'spring', stiffness: 200 }}
        data-testid="whatsapp-btn"
      >
        <div className="relative">
          {/* Pulse ring */}
          <span className="absolute inset-0 rounded-full bg-green-400 animate-ping opacity-75"></span>
          {/* Button */}
          <div className="relative w-14 h-14 rounded-full bg-green-500 hover:bg-green-600 shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center hover:scale-110">
            {/* Official WhatsApp Logo SVG */}
            <svg viewBox="0 0 32 32" className="w-7 h-7 fill-white">
              <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16c0 3.5 1.128 6.744 3.046 9.378L1.054 31.29l6.118-1.96C9.726 30.986 12.748 32 16.004 32 24.826 32 32 24.822 32 16S24.826 0 16.004 0zm9.37 22.614c-.392 1.106-1.938 2.022-3.192 2.29-.86.182-1.98.326-5.756-1.238-4.832-2-7.942-6.908-8.182-7.228-.23-.32-1.938-2.578-1.938-4.916s1.226-3.484 1.662-3.962c.392-.436 1.024-.654 1.63-.654.198 0 .376.01.536.018.436.02.654.048 .942.728.36.85 1.238 3.018 1.346 3.238.11.22.22.524.066.818-.144.304-.27.438-.49.69-.22.252-.43.444-.65.716-.198.238-.42.494-.178.93.242.436 1.076 1.776 2.31 2.876 1.59 1.418 2.93 1.858 3.344 2.066.32.16.706.128.96-.144.32-.35.716-.93 1.118-1.5.286-.408.646-.456 1.002-.304.364.144 2.3 1.086 2.694 1.284.394.198.656.296.754.458.096.16.096.93-.296 2.034z"/>
            </svg>
          </div>
        </div>
      </motion.a>

      {/* Made by I Design 4 U - Bottom Right */}
      <motion.a
        href="https://www.idesign4u.in"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50"
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 1.2, type: 'spring', stiffness: 200 }}
        data-testid="credit-btn"
      >
        <div className="px-4 py-2.5 rounded-full bg-gradient-to-r from-teal-600 to-teal-700 text-white text-sm font-medium shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300">
          Made by I Design 4 U
        </div>
      </motion.a>
    </>
  );
}
